export default __webpack_public_path__ + "static/media/chart-simple-solid-full-pink.b3eb60d6.svg";